import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://wogcqntwtphvghpguech.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZ2NxbnR3dHBodmdocGd1ZWNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAyNzMzMzgsImV4cCI6MjA4NTg0OTMzOH0.1aiUj-rGPChsZW4YcyAFJbJhsDBB2clfj9x776J23mw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
